import { ReactElement } from 'react';

import { Country } from '@dreryk/address-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { CountrySelect } from '@dreryk/react-components';

import { StyledCountryField } from './CountryField.styled';

export type CountryFormBeanPart = {
   country: Country;
};

type CountryFieldProps = {
   readonly register: BindingCreator<CountryFormBeanPart, 'country'>;
};

export const CountryField = (props: CountryFieldProps): ReactElement => {
   return (
      <StyledCountryField>
         <CountrySelect controller={props.register('country')} testId={'country'} />
      </StyledCountryField>
   );
};
